module.exports = __webpack_public_path__ + "static/unicorncomfblanket-b43b98821f843b872211f68165ed9d77.jpeg";